import { render, staticRenderFns } from "./bankAffs.vue?vue&type=template&id=7a8a19a0"
import script from "./bankAffs.vue?vue&type=script&lang=js"
export * from "./bankAffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports